import Head from 'next/head'

import { RightSideContent } from '~/ui/containers/base/base'
import { OpenAPISpec } from '~/ui/screens/settings/openapi_spec'
import { withAuth } from '~/utils/hoc'

function OpenAPISettingPage() {
  return (
    <>
      <Head>
        <title>Custom tools</title>
      </Head>
      <RightSideContent
        headerLinks={[
          {
            link: '/apps',
            text: 'Tools',
            icon: null,
          },
          {
            link: '#',
            text: 'Custom tools',
            icon: null,
          },
        ]}
        showTopBar={true}
      >
        <div className="px-8 pt-6">
          <OpenAPISpec />
        </div>
      </RightSideContent>
    </>
  )
}

export default withAuth(OpenAPISettingPage)
